import React from 'react';

function addjob() {
    return <div></div>;
}

export default addjob;

// import React from 'react';
// import { useForm } from 'react-hook-form';
// import { gql, useMutation } from '@apollo/client';
// import '../../styles/main.scss';
// import AddjobExplain from './addjobExplain';

// const ADDJOB_MUTATION = gql`
//     mutation addjobMutation($addjobInput: AddjobInput!) {
//         addjob(input: $addjobInput) {
//             shopId
//             shopPw
//             prodName
//         }
//     }
// `;

// interface IAddjobForm {
//     shopId: string;
//     shopPw: string;
//     prodName: string;
// }

// export default function Addjob() {
//     const { register, watch, errors, handleSubmit, getValues } = useForm<IAddjobForm>();

//     const onSubmit = () => {
//         const { shopId, shopPw, prodName } = getValues();
//         console.log(shopId);
//     };

//     return (
//         <>
//             <div id="addjobscss">
//                 <div className="apiWrap">
//                     <form className="apiForm">
//                         <h2>Play API</h2>
//                         {/* <!-- 쇼핑몰 정보 --> */}
//                         <div className="basic">
//                             <AddjobExplain />
//                         </div>
//                         <div className="engCont">
//                             <div className="formArea">
//                                 <label>쇼핑몰정보</label>
//                                 <div className="inputArea">
//                                     <div>
//                                         <input type="text" placeholder="쇼핑몰 ID" />
//                                         <input type="password" placeholder="쇼핑몰 비밀번호" />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         {/* <!-- 상품 마스터 정보 --> */}
//                         <div className="engCont">
//                             {/* <!-- 정보입력란 --> */}
//                             <div className="formArea">
//                                 <label>상품 마스터 정보</label>
//                                 <div className="inputArea">
//                                     <div>
//                                         <input type="text" placeholder="상품명" />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         {/* <!-- 폼버튼 --> */}
//                         <div className="btnArea">
//                             {/* <button onClick={handelClickRegistProd}>테스트 상품등록 작업 시작하기</button> */}
//                             <button>테스트 상품수정 작업 시작하기</button>
//                         </div>
//                     </form>
//                 </div>
//             </div>
//         </>
//     );
// }
